// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BankidController from "./bankid_controller"
application.register("bankid", BankidController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import IduraController from "./idura_controller"
application.register("idura", IduraController)
